import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
} from 'reactstrap';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';

const EditPhysicalAddress = (props) => {
  const [disabled, setDisabled] = useState(true);

  const handleValueChange = () => {
    setDisabled(false);
  };

  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle} size="md">
      <ModalHeader toggle={props.toggle}>
        Edit Physical Address
        <button type="button" className="close" onClick={props.toggle} aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>

        <Input
          label="Address Line 1"
          name="addressLine1"
          onChange={handleValueChange}
          isRequired
        />

        <Input
          label="Address Line 2"
          name="addressLine2"
          onChange={handleValueChange}
          isRequired
        />

        <Input
          label="City"
          name="addressCity"
          onChange={handleValueChange}
          isRequired
        />

        <Row>
          <Col xs={6}>
            <Select
              name="addressState"
              data={[
                { value: 'California', title: 'California' },
                { value: 'Illinois', title: 'Illinois' },
              ]}
              value="California"
              onChange={() => {}}
              label="State"
              isRequired
            />
          </Col>
          <Col xs={6} className="pl-0">
            <Input
              type="tel"
              name="addressZip"
              onChange={handleValueChange}
              label="Zip Code"
              isRequired
              mask={Number}
            />
          </Col>
        </Row>

        <Button color="primary" className="w-100 mt-1" disabled={disabled}>Save</Button>

      </ModalBody>
    </Modal>
  );
};

EditPhysicalAddress.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default EditPhysicalAddress;
